<template>
  <div class="v-badge__wrapper" :class="{ [extraClass]: true }">
    {{ label }}
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
export default Vue.component("VBadge", {
  props: {
    label: VueTypes.string.isRequired,
    extraClass: VueTypes.string.def("")
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-badge";

.#{$ns} {
  &__wrapper {
    font-family: "Lato Medium", Arial, sans-serif;
    cursor: default;
    color: #606060;
    font-size: 12px;
    text-align: center;
    height: 20px;
    width: 66px;
    border-radius: 4px;
    border: 1px solid #9a9a9a;
    line-height: 1.5;
  }
}
</style>
